import newWaysToNomSrc from '@images/marketing/Home-Map.jpg';
export var waysToNomContent = {
    headline: 'More Ways to Nom',
    subhead: 'Not into a monthly dog food subscription? Fetch our recipes whenever you want them from your favorite retailer.',
    imageData: {
        src: newWaysToNomSrc,
        alt: 'Fake map of Nom Nom retail locations',
    },
    ctas: [
        {
            label: 'Shop at Chewy',
            url: 'https://redir.pricespider.com/redirect?cid=66c7787e21e16619000c0cf0&url=https%3A%2F%2Fwww.chewy.com%2Fbrands%2Fnom-nom-136126&landingPageId=501',
        },
        {
            label: 'Shop at PetSmart',
            url: 'https://redir.pricespider.com/redirect?cid=66c7787e21e16619000c0cf0&url=https%3A%2F%2Fwww.petsmart.com%2Ffeatured-brands%2Fnom-nom&landingPageId=502&vid=989036',
        },
    ],
};
